// The action system reads Cmd where it reads Ctrl elsewhere, so a few defaults differ per platform.
export const isMac = /Mac|iPod|iPhone|iPad/.test(globalThis.navigator?.platform ?? '')
